import { COLORS } from '@btime/constants'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { usePeriodicFormReplies } from './_load/PeriodicFormRepliesLoader'
import ColumnChart from '../../../../../packages/kiti-charts/components/charts/ColumnChart'
import LineChart from '../../../../../packages/kiti-charts/components/charts/LineChart'

const Chart = ({ widget }) => {
  const { t } = useTranslation('common')
  const data = usePeriodicFormReplies().reduce((acc, item) => {
    return [...acc, { ...item, type: t('widgets.total'), value: item.totalCount }]
  }, [])

  let Component = LineChart
  switch (widget.data?.presentation) {
    case 'column':
      Component = ColumnChart
      break
  }

  const config = {
    data,
    xField: 'date',
    yField: 'value',
    seriesField: 'type',
    colorField: 'type',
    color: [COLORS.blue]
  }
  return <Component {...config} />
}

export default Chart
